/**
 * 公共方法
 */

export default {
  /**
   * 设置全局主题色
   * @param {string} color  颜色
   */
  setMainColor(color) {
    document
      .getElementsByTagName('body')[0]
      .style.setProperty('--mainColor', color);
  },

  /**
   * 获取地址栏参数
   */
  getUrlParam(name) {
    return (
      decodeURIComponent(
        (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
          location.href,
        ) || [null, ''])[1].replace(/\+/g, '%20'),
      ) || null
    );
  },

  getRequestParamObj(array) {
    let obj = {};
    array = array || ['appId', 'id', 'timeNo', 'identity', 'useThirdPage', 'openId', 'ticket', 'miniProgramWxAuth'];
    array.forEach(item => {
      obj[item] = this.getDataByKey(item);
    });
    return obj;
  },

  getDataByKey(item) {
    if (item !== 'identity') {
      return this.getUrlParam(item) || localStorage.getItem(item);
    }
    return this.getUrlParam(item);
  },

  isMiniProgramWxAuth() {
    const value = this.getDataByKey('miniProgramWxAuth');
    return value === '1' || value === 1 || value === true || value === 'true';
  },

  isMyApp: function (usSign) {

    let ua = navigator.userAgent;
    let appId = localStorage.getItem("appId");
    // 根据appId判断为宜昌租户，然后判断是否为鸿蒙app
    if (appId === "ec445803d2e14f82a20ecf38259a58da") {
      if (ua.indexOf("wjxMediaX") > -1) {
        return true;
      }
    }
    if (ua.indexOf(usSign) > -1) {
      return true;
    }
    // 端内上方优先判断 然后冀时办判断是否是支付宝小程序
    if (location.href.includes('activity.szjiyun.com')) {
      const isMyApp = this.getDataByKey('isApp')
      if (Number(isMyApp) === 1) {
        return true;
      }
      console.log('冀时办-支付宝小程序 或微信小程序')
      return this.isAlipayMiniProgram() || this.isWechatMiniProgram()
    }
    return false;
  },

  getSystem: function () {
    let ua = navigator.userAgent;
    let Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPod',
      'iPad',
    ];
    let flag = true;
    for (var i = 0; i < Agents.length; i++) {
      if (ua.indexOf(Agents[i]) > 0) {
        flag = false;
        break;
      }
    }
    if (flag) {
      return 'PC';
    } else {
      if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
        return 'Android';
      }
      if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return 'IOS';
      }
    }
  },

  //获取分享信息
  getShareParams: function (list) {
    let obj = {};
    list.forEach(ele => {
      if (ele.name == 'shareTitle') {
        obj['title'] = ele.content;
      }
      if (ele.name == 'description') {
        obj['desc'] = ele.content;
      }
      if (ele.name == 'shareLink') {
        obj['link'] = decodeURIComponent(ele.content);
      }
      if (ele.name == 'shareImage') {
        obj['imgUrl'] = ele.content;
      }
    });
    return obj;
  },
  // 判断是否为支付宝小程序
  isAlipayMiniProgram: function () {
    // 优先获取UA（浏览器/小程序环境均支持）
    const userAgent = navigator.userAgent || '';

    // 组合判断：优先匹配专属标识 AlipayMiniProgram，再匹配 AlipayClient 提高兼容性
    return /AlipayMiniProgram/i.test(userAgent) || /AlipayClient/i.test(userAgent);
  },
  isWechatMiniProgram: function () {
    // 优先获取UA（浏览器/小程序环境均支持）
    const userAgent = window.navigator.userAgent.toLowerCase() || '';

    // - 必须包含微信标识（MicroMessenger）
    // - 必须包含小程序特征关键字（miniProgram）
    return /miniprogram/i.test(userAgent) && /micromessenger/i.test(userAgent);
  },
  /**
   * 连续点击触发加载 VConsole 工具方法
   * 闭包保存状态，避免全局变量污染，支持多组件独立使用
   * @param {Object} options 配置项
   * @param {number} options.threshold 触发阈值（默认 20 次）
   * @param {number} options.timeout 超时时间（默认 1000 毫秒）
   * @returns {Function} 点击事件处理方法
   */
  createVConsoleTrigger: function (options = {}) {
    // 默认配置
    const DEFAULT_CONFIG = {
      threshold: 15,
      timeout: 1000
    };
    const config = { ...DEFAULT_CONFIG, ...options };

    // 闭包保存状态（每个组件调用该方法会生成独立的状态，互不干扰）
    let clickCount = 0;
    let clickTimer = null;

    // 加载 VConsole 核心方法
    const loadVc = () => {
      if (window.VConsole) {
        if (!document.querySelector('.vconsole')) {
          new window.VConsole();
        }
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://www.media.xinhuamm.net/js/xinhua-sdk/vconsole.min.js';
      script.onload = () => {
        new window.VConsole();
      };
      script.onerror = (err) => {
        console.error('VConsole 脚本加载失败：', err);
      };
      document.head.appendChild(script);
    };

    // 返回点击处理方法，供组件调用
    return function handleVConsoleClick() {
      // 1. 计数器 +1
      clickCount++;
      console.log(`当前连续点击次数：${clickCount}`);

      // 2. 清除旧定时器
      clearTimeout(clickTimer);

      // 3. 设置新定时器，超时重置
      clickTimer = setTimeout(() => {
        clickCount = 0;
        console.log('点击超时，重置 VConsole 触发计数器');
      }, config.timeout);

      // 4. 达到阈值触发加载
      if (clickCount >= config.threshold) {
        loadVc();
        clickCount = 0;
        clearTimeout(clickTimer);
        console.log(`连续点击${config.threshold}次，触发 VConsole 加载`);
      }
    };
  }
  /**
   * 格式化日期
   * @param {string|number|Date} date 输入日期，可以是字符串、时间戳或 Date 对象
   * @returns {string} 格式化后的日期字符串，格式为 "YYYY-MM-DD HH:mm"
   */
  , formatDate(date) {
    if (!date) return '';
    const d = new Date(date.replace(/-/g, '/'));
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}/${month}/${day} ${hours}:${minutes}`;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/commonHelper.js